import _ from 'lodash';

const processStrategy = (deviceStopHistory) => {
  const relations = {};
  const omit = [];
  return {
    ..._.omit(deviceStopHistory, omit),
    ..._.pickBy(relations, _.identity),
  };
};

export default {
  key: 'deviceStopHistory',
  definition: {},
  processStrategy,
};
